import {connect} from 'react-redux';
import Step2 from './Step2';
import {submitStep} from '../../actions/submitStep';
import {uploadFile} from '../../actions/uploadFile';
import {showGlobalErrorMessage} from '../../actions/globalErrorMessage/showGlobalErrorMessage';
import {prevCompletedStepSignFalse} from "../../actions/prevCompletedStepSign/prevCompletedStepSignFalse";
import {checkIdNumber} from '../../actions/checkIdNumber';

const mapStateToProps = ({
                           regType: {regType},
                           locales: {current: language},
                           stepPayload: {payload},
                           prevCompletedStepSign: {prevCompletedStepSign}
                         }) => ({
  regType,
  language,
  payload,
  prevCompletedStepSign
});

export default connect(
  mapStateToProps,
  {
    submitStep,
    uploadFile,
    showGlobalErrorMessage,
    prevCompletedStepSignFalse,
    checkIdNumber
  }
)(Step2);
